// extracted by mini-css-extract-plugin
export var deleteIcon = "_th-5";
export var deleteOption = "_th-3";
export var divider = "_th-2";
export var downloadIcon = "_th-4";
export var drawer = "_th-0";
export var drawerFooter = "_th-6";
export var drawerOpen = "_th-1";
export var highlighted = "_th-7";
export var lighterHighlight = "_th-8";